/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Markers_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Markers published successfully" |
*
* @param {Iconik_Publish_Markers_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_markers_success_toast = /** @type {((inputs?: Iconik_Publish_Markers_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Markers_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Markers published successfully")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markers published successfully")
	if (locale === "it") return /** @type {LocalizedString} */ ("Markers published successfully")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Markers published successfully")
	if (locale === "es") return /** @type {LocalizedString} */ ("Markers published successfully")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Markers published successfully")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Markers published successfully")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Markers published successfully")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Markers published successfully")
	return /** @type {LocalizedString} */ ("Markers published successfully")
});